<template>
  <div class="@container flex flex-col gap-4">
    <!-- The title must stay on one line (#6331). It is 20.4x its font size wide, so 4.8cqi keeps a
         small margin inside the card at any width; the cap matches the other panel headings. -->
    <h3 class="text-[length:min(18px,4.8cqi)] font-bold whitespace-nowrap">
      Ik bereken jouw impact na einde saldering
    </h3>
    <p class="text-base font-light leading-5 text-body">
      Vul je verbruik in en ik bereken binnen 10 seconden jouw mogelijke extra kosten en maak een
      <strong>gratis</strong> persoonlijk actieplan om deze te beperken.
    </p>

    <div class="h-px w-full bg-line" />

    <div class="flex flex-col items-center gap-3">
      <img :src="house" alt="" class="tl-house h-16 w-[70px]" />

      <div class="flex w-full items-center gap-2">
        <span class="text-[18px] font-medium text-orange">2026</span>
        <!-- Pure illustration; the caption below carries the message for screen readers. -->
        <div class="relative h-10 flex-1" aria-hidden="true">
          <span class="tl-line" />
          <span
            v-for="euro in EURO_SIGNS"
            :key="euro.left"
            class="tl-euro font-bold text-orange"
            :style="{
              left: euro.left,
              fontSize: `${euro.size}px`,
              opacity: euro.opacity,
              animationDelay: `${euro.delay}s`,
            }"
          >
            €
          </span>
          <span class="tl-orb-track"><span class="tl-orb" /></span>
        </div>
        <span class="text-[18px] font-medium text-body">2027</span>
      </div>

      <!-- Visually the animation tells this itself (#6331); screen readers still get the words,
           since the illustration is aria-hidden. -->
      <p class="sr-only">Van opwek naar kosten: de situatie vanaf 1 januari 2027</p>
    </div>
  </div>
</template>

<script setup lang="ts">
import house from '@/assets/svg/house.svg'

/**
 * The euro signs shrink and fade along the timeline: netting yields less and less towards 2027.
 * The delays follow the orb, so every sign ticks the moment the orb passes it.
 */
const EURO_SIGNS = [
  { left: '6%', size: 18, opacity: 1, delay: 0.05 },
  { left: '29%', size: 16, opacity: 0.9, delay: 0.55 },
  { left: '52%', size: 14, opacity: 0.78, delay: 1.05 },
  { left: '74%', size: 12, opacity: 0.63, delay: 1.55 },
  { left: '95%', size: 10, opacity: 0.5, delay: 2.05 },
]
</script>
